import React from "react";
import SensorBase from "./SensorBase";
import {  TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";
import { TCustomProcessFn } from "../types";
import IrrigationHour from "../../../components/IrrigationHour";

const FIELD = "soilMoisture1";
const UNIT = "kPa";


// Helper function to generate color for an item
const generateColorForItem = (item: TDataItem): string => {
  const { soilMoisture1, minThresholdValue, minOptimalValue, maxOptimalValue, maxThresholdValue } = item;
  if (soilMoisture1 < minThresholdValue) return "red"; // Below min threshold
  if (soilMoisture1 >= minThresholdValue && soilMoisture1 < minOptimalValue) return "#F4D03F"; // yellow
  if (soilMoisture1 >= minOptimalValue && soilMoisture1 <= maxOptimalValue) return "#0c9611"; // green
  if (soilMoisture1 > maxOptimalValue && soilMoisture1 <= maxThresholdValue) return "#F4D03F"; // yellow
  if (soilMoisture1 > maxThresholdValue) return "red"; // Above max threshold

  return "#0c9611";  //default green
};

const customProcessFn: TCustomProcessFn = (
  graphData: TSensorDataResponse,
  startDate: string,
  endDate: string
) => {
  console.log("Start Date:", startDate, "End Date:", endDate);

  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForItem(item),   
  }));

  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,  
    color: updatedSample.map((item) => item.color),  
  };
};

const SoilMoisture1: React.FC = () => {
  return (
    <div>
      <SensorBase field={FIELD} unit={UNIT}  
        customProcessFn={customProcessFn}></SensorBase>
      <IrrigationHour />
    </div>
  );
};

export default SoilMoisture1;